import * as React from "react";

function SvgSegMetrics(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="8 15 40 40"
      {...{ ...props, ref }}
    >
      <defs>
        <clipPath id="SegMetrics_svg__a">
          <rect
            x={13.32}
            y={20.14}
            width={31.72}
            height={31.72}
            rx={0.98}
            fill="none"
          />
        </clipPath>
      </defs>
      <g clipPath="url(#SegMetrics_svg__a)">
        <path fill="#fbc42f" d="M7.12 14.54h45.5V46.7H7.12z" />
        <path
          d="M53 47.06H6.75V14.17H53zm-45.5-.73h44.75V14.9H7.48z"
          fill="#fff"
        />
        <path
          fill="#4abecc"
          d="M40.73 29.28l-5.55 14.98-8.92-6.27-7.4 6.27-1.9-1.53-7.69-5.35v18.75l37.37.33V28.55l-5.91.73z"
        />
        <path
          d="M47.37 57.19l-38.83-.34V36l8.83 6.14 1.48 1.19 7.37-6.25 8.61 6 5.38-14.51 7.16-.89zM10 55.41l35.92.31V29.37l-4.66.63-5.72 15.4-9.24-6.49-7.42 6.3-2.38-1.91-6.5-4.52z"
          fill="#fff"
        />
      </g>
      <circle cx={19.2} cy={44.25} r={2.45} fill="#fff" />
      <path
        d="M19.2 46.86a2.61 2.61 0 112.61-2.61 2.61 2.61 0 01-2.61 2.61zm0-4.9a2.29 2.29 0 102.29 2.29A2.29 2.29 0 0019.2 42z"
        fill="#fff"
      />
      <circle cx={26.6} cy={37.97} r={2.45} fill="#fff" />
      <path
        d="M26.6 40.58A2.61 2.61 0 1129.21 38a2.61 2.61 0 01-2.61 2.58zm0-4.89A2.29 2.29 0 1028.89 38a2.28 2.28 0 00-2.29-2.31z"
        fill="#fff"
      />
      <circle cx={35.52} cy={44.25} r={2.45} fill="#fff" />
      <path
        d="M35.52 46.86a2.61 2.61 0 112.61-2.61 2.61 2.61 0 01-2.61 2.61zm0-4.9a2.29 2.29 0 102.28 2.29A2.3 2.3 0 0035.52 42z"
        fill="#fff"
      />
      <circle cx={41.07} cy={29.26} r={2.45} fill="#fff" />
      <path
        d="M41.07 31.88a2.62 2.62 0 112.61-2.62 2.62 2.62 0 01-2.61 2.62zm0-4.9a2.29 2.29 0 102.29 2.28A2.28 2.28 0 0041.07 27zM25.7 27h-.55a.2.2 0 00-.2.2v3.26a.2.2 0 00.2.2h.55zm8.85 0H26.6v3.66h7.95s1.88-1.51 1.88-1.83S34.55 27 34.55 27z"
        fill="#fff"
      />
    </svg>
  );
}

export default React.forwardRef(SvgSegMetrics);
